<i class="{{icon}}"></i>
<label for="{{uuid}}-input">{{ label }}</label>
<input id="{{uuid}}-input" class="form-control" [class.iconized]="icon"
       [type]="type || 'text' "
       [readOnly]="readonly"
       [formControlName]="inputName"
       [placeholder]="placeholder"
       appInputHasError
>
